import React from 'react';
import '../scss/components/section.scss';
import Header from '../components/header/header.jsx';
import Footer from '../components/footer/footer-v1/index.jsx';
import dataFooter from '../assets/fake-data/data-footer.js';
import Bottom from '../components/bottom/index.jsx';

function PrivacyPolicy(props) {
    return (
        <div className='wrapper-style sv2-tnc-prvcy' id='wrapper'>
            {<Header />}
            <div className='sellagen-fact'>
                <h2 className="sellagen-fact-title"><strong>Privacy Policy</strong></h2>
                <br/>
                <p><strong>Last updated: July 21, 2025</strong></p>
                <br/><br/>
                <p><strong>SELLAGEN Inc.</strong> (“SELLAGEN,” “Nelima,” “we,” “us,” or “our”) is committed to protecting your privacy. This Privacy Policy (“Policy”) explains how we collect, use, and disclose Personal Information when you access and use our products, services, and applications (collectively, “Services”) and our websites and online platforms (collectively, the “Site”), including during any interactions such as applying for employment. This Policy also outlines your rights under applicable laws.</p>
                <br/>
                <br/>
                <p>This Policy applies when SELLAGEN acts as a <strong>“data controller”</strong> with respect to your Personal Information. When we process data solely on behalf of a customer or third party (i.e., as a <strong>“data processor”</strong>), their respective privacy policy governs.</p>
                <br/>
                <br/>
                <p>We may issue specific privacy notices for certain contexts; those notices supersede this Policy for that context.</p>
                <br/>
                <br/>
                <p>If you provide Personal Information about others, you are responsible for ensuring you have lawful grounds to do so, including obtaining any required consents.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Personal Information We Collect</h3>
                <br/>
                <p>“Personal Information” means information that identifies, relates to, describes, or could reasonably be linked with a person. We collect the following categories:</p>
                <br/>
                <h4 className='fw-6'>Contact Information</h4>
                <br/>
                <p>Name, email address, phone number, mailing address.</p>
                <br/>
                <h4 className='fw-6'>Account Credentials</h4>
                <br/>
                <p>Username, password, third-party account tokens, and related metadata.</p>
                <br/>
                <h4 className='fw-6'>Text Messaging Preferences</h4>
                <br/>
                <p>Phone number and opt-in status for Nelima’s text messages, including message history and interaction logs.</p>
                <br/>
                <h4 className='fw-6'>Connected App Data</h4>
                <br/>
                <p>With your explicit authorization, we access limited metadata and content from connected third-party services (e.g., Gmail, Google Drive, Notion), including but not limited to email subject lines, file names, calendar event titles, timestamps, and entity references needed to perform tasks.</p>
                <br/>
                <h4 className='fw-6'>Usage Information</h4>
                <br/>
                <p>IP address, device identifiers, session IDs, browser type, referring URLs, timestamps, and interactions with the Site and Services.</p>
                <br/>
                <h4 className='fw-6'>Communications</h4>
                <br/>
                <p>Messages you send to us via email, chat, or other channels; call recordings where permitted.</p>
                <br/>
                <h4 className='fw-6'>Financial Information</h4>
                <br/>
                <p>Payment data and billing details collected through a secure third-party payment processor.</p>
                <br/>
                <h4 className='fw-6'>Employment Information</h4>
                <br/>
                <p>If you apply for a role, we may collect information from your application, CV/resume, references, and background check results.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>How We Collect Personal Information</h3>
                <br/>
                <h4 className='fw-6'>Directly from You</h4>
                <br/>
                <p>When you create an account, connect third-party services, instruct Nelima to perform tasks, or communicate with us.</p>
                <br/>
                <h4 className='fw-6'>Through Third-Party Integrations</h4>
                <br/>
                <p>When you link external services (e.g., Google, Notion, Slack), we collect authorized data via those services’ APIs to fulfill your requests.</p>
                <br/>
                <h4 className='fw-6'>Automatically</h4>
                <br/>
                <p>Via cookies, server logs, and tracking technologies.</p>
                <br/>
                <h4 className='fw-6'>From Third Parties</h4>
                <br/>
                <p>Service providers, analytics vendors, recruiters, or background check services.</p>
                <br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>How We Use Personal Information</h3>
                <br/>
                <p>We use your Personal Information for the following purposes:</p>
                <br/>
                <p>&emsp;• <strong>Service Delivery</strong> – Authenticate users, run tasks across integrated apps, respond to your prompts, process transactions, and provide customer support.</p>
                <br/>
                <p>&emsp;• <strong>Text Messaging</strong> – Send and manage Nelima’s text messages, track opt-in status, and maintain message history.</p>
                <br/>
                <p>&emsp;• <strong>Product Optimization</strong> – Analyze interactions to identify bugs, optimize performance, and improve task execution quality.</p>
                <br/>
                <p>&emsp;• <strong>Research and Development</strong> – Analyze aggregated, de-identified usage patterns to enhance our Services and develop new features.</p>
                <br/>
                <p>&emsp;• <strong>Communication</strong> – Provide operational updates, respond to inquiries, and send policy or security notices.</p>
                <br/>
                <p>&emsp;• <strong>Legal and Security</strong> – Enforce our Terms, detect and prevent fraud or abuse, and comply with legal obligations.</p>
                <br/>
                <p>&emsp;• <strong>Business Transactions</strong> – Support mergers, acquisitions, or asset sales as legally permitted.</p>
                <br/>
                <p>&emsp;• <strong>Employment</strong> – Process job applications, conduct interviews, and manage recruiting workflows.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}


                <h3 className='fs-20 text-color-4'>How We Disclose Personal Information</h3>
                <br/>
                <p>We do not sell Personal Information. We may disclose it as follows:</p>
                <br/>
                <p>&emsp;• <strong>Personnel</strong> – Employees, contractors, and agents with a legitimate need to know.</p>
                <br/>
                <p>&emsp;• <strong>Service Providers</strong> – Infrastructure hosting (e.g., AWS), authentication services, payment processors, analytics vendors, and support tools.</p>
                <br/>
                <p>&emsp;• <strong>Connected Third-Party Platforms</strong> – Only to the extent required to execute tasks on your behalf (e.g., sending an email using your Gmail account).</p>
                <br/>
                <p>&emsp;• <strong>Legal Authorities </strong> – To comply with law enforcement or other lawful obligations.</p>
                <br/>
                <p>&emsp;• <strong>Corporate Transactions</strong> – As part of a merger, acquisition, or bankruptcy process.</p>
                <br/>
                <p>&emsp;• <strong>With Consent</strong> – To other third parties when you explicitly authorize it.</p>
                <br/>
                <p>All third-party access is governed by agreements requiring appropriate confidentiality and data handling safeguards.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Cookies and Tracking Technologies</h3>
                <br/>
                <p>We use cookies, pixel tags, and local storage to collect analytics, improve site performance, remember your preferences, and secure your account. We may use:</p>
                <br/>
                <p>&emsp;• <strong>Google Analytics</strong> – For traffic and usage insights. See Google’s Privacy Policy for opt-out tools.</p>
                <br/>
                <p>&emsp;• <strong>Session Replay Tools</strong> – To observe anonymized user interactions for debugging and design improvements.</p>
                <br/>
                <p>You can modify cookie preferences in your browser or through in-app settings. Some features may not work properly if cookies are disabled.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Cross-Border Data Transfers</h3>
                <br/>
                <p>SELLAGEN is headquartered in the United States. If you access the Services from outside the U.S., you understand that your Personal Information may be transferred to, stored in, and processed in the U.S. and other jurisdictions where data protection laws may differ.</p>
                <br/>
                <p>We rely on lawful transfer mechanisms (such as Standard Contractual Clauses) where required by law.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Data Retention</h3>
                <br/>
                <p>We retain Personal Information:</p>
                <br/>
                <p>&emsp;• While your account is active</p>
                <p>&emsp;• As necessary to provide the Services</p>
                <p>&emsp;• To comply with legal obligations and resolve disputes</p>
                <p>&emsp;• For internal audit, security, and fraud prevention</p>
                <br/>
                <p>We regularly review retention periods and delete or de-identify data that is no longer needed.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Your Rights</h3>
                <br/>
                <p>Depending on your jurisdiction, you may have the right to:</p>
                <br/>
                <p>&emsp;• Access, correct, or delete your Personal Information</p>
                <p>&emsp;• Withdraw consent for certain processing activities</p>
                <p>&emsp;• Object to or restrict certain uses</p>
                <p>&emsp;• Request data portability</p>
                <br/>
                <p>To exercise these rights, contact us at <strong>support@sellagen.com</strong>. We may ask you to verify your identity before fulfilling your request.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Children’s Privacy</h3>
                <br/>
                <p>Our Services are not directed at children under 13 (or the minimum age defined under applicable law). We do not knowingly collect Personal Information from children.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Changes to This Policy</h3>
                <br/>
                <p>We may update this Policy periodically. If we make material changes, we will notify you by email or by posting an update on our Site, with the revised effective date.</p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

                <h3 className='fs-20 text-color-4'>Contact Us</h3>
                <br/>
                <p>For any questions about this Privacy Policy, please reach out:
                    <br/>
                    <strong>support@sellagen.com</strong>
                    <br/>
                    SELLAGEN Inc.
                </p>
                <br/><br/><br/>

                {/* ## END OF SUBSECTION */}

            </div>
            {<Footer data={dataFooter}/>}
            {<Bottom classection='widget-social-footer'/>}
        </div>
    );
}

export default PrivacyPolicy